module.exports = __webpack_public_path__ + "img/台心.a67ff00.png";